export default __webpack_public_path__ + "static/media/no-icon.a2fdb1a5.svg";